
export const followUpQuestions = {
  // Följdfrågor för arbetsmiljörisker
  "arbetsmiljo_1": [
    { id: "buller_niva", text: "Finns det risk för hörselskador på grund av buller över 85 dB(A)?", category: "Buller" },
    { id: "kemikalier_exponering", text: "Finns det exponering för farliga kemikalier eller damm?", category: "Kemikalier" },
    { id: "ergonomi_tunga_lyft", text: "Förekommer tunga lyft över 25 kg eller repetitiva rörelser?", category: "Ergonomi" },
    { id: "fallrisker_hogt", text: "Finns det arbete på höjd över 2 meter utan skydd?", category: "Fallrisker" }
  ],
  
  "arbetsmiljo_2": [
    { id: "ventilation_otillracklig", text: "Är ventilationen otillräcklig i arbetsområdet?", category: "Ventilation" },
    { id: "belysning_otillracklig", text: "Är belysningen under 500 lux på arbetsplatsen?", category: "Belysning" },
    { id: "temperatur_extrem", text: "Förekommer extrema temperaturer (under 16°C eller över 26°C)?", category: "Temperatur" }
  ],

  "maskiner_1": [
    { id: "roterande_delar", text: "Finns det oskyddade roterande maskindelar?", category: "Maskinsäkerhet" },
    { id: "hydraulisk_tryck", text: "Används hydraulsystem med tryck över 100 bar?", category: "Hydraulik" },
    { id: "elektrisk_risk", text: "Finns risk för elektriska stötar från maskiner?", category: "El-säkerhet" }
  ],

  "brand_1": [
    { id: "brandfarliga_amnen", text: "Hanteras brandfarliga ämnen (klass 1-3)?", category: "Brandfarliga ämnen" },
    { id: "utrymningsmojligheter", text: "Är utrymningsvägarna fria och tydligt markerade?", category: "Utrymning" },
    { id: "brandslapning", text: "Finns lämpliga brandsläckningsmedel tillgängliga?", category: "Brandsläckning" }
  ],

  "transport_1": [
    { id: "truck_kollision", text: "Finns risk för kollision mellan truckar och gående?", category: "Transportrisker" },
    { id: "lasthantering", text: "Kan laster falla ned eller välta under transport?", category: "Lasthantering" },
    { id: "transportvagar", text: "Är transportvägarna fria från hinder och väl markerade?", category: "Transportvägar" }
  ],

  "miljo_1": [
    { id: "kemiskt_utslapp", text: "Finns risk för utsläpp av kemikalier till mark eller vatten?", category: "Utsläpp" },
    { id: "avfall_hantering", text: "Hanteras farligt avfall enligt gällande föreskrifter?", category: "Avfallshantering" },
    { id: "luftemissioner", text: "Kan verksamheten orsaka luftföroreningar?", category: "Luftemissioner" }
  ],

  "informationssakerhet_1": [
    { id: "dataskydd_gdpr", text: "Hanteras personuppgifter enligt GDPR?", category: "Dataskydd" },
    { id: "cybersecurity", text: "Finns risk för cyberattacker eller dataintrång?", category: "IT-säkerhet" },
    { id: "backup_rutiner", text: "Finns fungerande backup-rutiner för kritisk data?", category: "Databackup" }
  ],

  "ekonomisk_1": [
    { id: "kostnadsoverskridning", text: "Finns risk för betydande kostnadsöverskridningar?", category: "Budget" },
    { id: "leverantorsrisker", text: "Kan leverantörer påverka projektets ekonomi negativt?", category: "Leverantörer" },
    { id: "valutarisker", text: "Påverkas projektet av valutaförändringar?", category: "Valuta" }
  ],

  "juridisk_1": [
    { id: "tillstand_saknas", text: "Saknas nödvändiga tillstånd eller certifieringar?", category: "Tillstånd" },
    { id: "kontraktsrisker", text: "Finns oklarheter i kontrakt eller avtal?", category: "Kontrakt" },
    { id: "ansvarsfordelning", text: "Är ansvarsfördelningen mellan parter otydlig?", category: "Ansvar" }
  ],

  "teknisk_1": [
    { id: "system_integration", text: "Finns risk för problem vid systemintegration?", category: "Integration" },
    { id: "teknisk_obsolescence", text: "Kan teknik bli föråldrad under projektets livstid?", category: "Teknisk utveckling" },
    { id: "kvalitetsbrister", text: "Finns risk för kvalitetsbrister i tekniska lösningar?", category: "Kvalitet" }
  ],

  "projektorganisation_1": [
    { id: "resursbrist", text: "Finns risk för brist på nyckelresurser?", category: "Resurser" },
    { id: "kommunikationsbrister", text: "Kan kommunikationsbrister påverka projektet?", category: "Kommunikation" },
    { id: "tidsproblem", text: "Finns risk för förseningar i kritiska aktiviteter?", category: "Tidplan" }
  ]
};

export const getFollowUpQuestionsForCategory = (categoryKey: string) => {
  return followUpQuestions[categoryKey as keyof typeof followUpQuestions] || [];
};
